import { LangText } from '@/components';

/** 机场行李配送 — 注意事项 */
export default function LuggagePrecautionsPage() {
  return (
    <div className="min-h-[calc(100vh-var(--spacing)*45)] bg-white">
      <div className="mx-auto max-w-3xl px-6 py-10 md:px-10">
        <h1 className="text-[24px] md:text-[28px] font-bold text-[#1a1a1a] mb-8">
          <LangText lngKey="487853f3" />
        </h1>
        <div className="text-[15px] leading-[1.75] text-[#333333]">
          <LangText lngKey="2704e0ed" className="block whitespace-pre-wrap" />
        </div>
      </div>
    </div>
  );
}
